module.exports = require("@jinyexin/core");